import React from 'react'
import { MainLayout } from '@/components/layout/MainLayout'
import { useParams, Navigate } from 'react-router-dom'
import CampaignStepper from '@/components/campaign/CampaignStepper'
import Step1Basics from '@/components/campaign/steps/Step1Basics'
import Step2CreativeBrief from '@/components/campaign/steps/Step2CreativeBrief'
import Step3Review from '@/components/campaign/steps/Step3Review'

const CampaignSteps: React.FC = () => {
  const { step } = useParams<{ step: string }>()

  // Extract step number from step parameter (e.g., "step1" -> 1)
  const stepMatch = step?.match(/^step(\d+)$/)
  const currentStep = stepMatch ? parseInt(stepMatch[1], 10) : 1

  // Validate step number (now only 3 steps)
  if (!stepMatch || isNaN(currentStep) || currentStep < 1 || currentStep > 3) {
    return <Navigate to="/campaign/create/step1" replace />
  }

  return (
    <div className="mx-auto max-w-5xl px-4 py-8 sm:px-6">
      <h1 className="text-3xl font-bold mb-6 tracking-tight text-foreground">Create Campaign</h1>

      <CampaignStepper />

      {currentStep === 1 && <Step1Basics />}
      {currentStep === 2 && <Step2CreativeBrief />}
      {currentStep === 3 && <Step3Review />}
    </div>
  )
}

const CampaignCreate: React.FC = () => {
  return (
    <MainLayout>
      <CampaignSteps />
    </MainLayout>
  )
}

export default CampaignCreate
